<ng-container *ngIf="viewState$ | async as vm">
<div data-testid="vehicle-wizard" [attr.data-step]="vm.step" class="web-vehicle-wizard__shell">
  <nav #stepper class="web-vehicle-wizard__steps" role="tablist"
       [attr.aria-label]="'features.user.garage.mobile_wizard.title' | translate">
    <button *ngFor="let visibleStep of visibleSteps; let index = index"
            pButton pRipple type="button" class="p-button-text p-button-rounded web-vehicle-wizard__step"
            [class.is-active]="visibleStep === vm.step"
            [attr.aria-current]="visibleStep === vm.step ? 'step' : null"
            [disabled]="!canNavigate(visibleStep)"
            (click)="goTo(visibleStep)">
      <span class="p-badge p-component">{{ index + 1 }}</span>
      <span class="web-vehicle-wizard__step-copy">
        <span class="web-vehicle-wizard__step-label">{{ stepLabel(visibleStep) | translate }}</span>
        <strong *ngIf="$any(selected)[visibleStep] as choice" class="web-vehicle-wizard__step-value">{{ label(choice) }}</strong>
      </span>
    </button>
  </nav>

  <main #content class="web-vehicle-wizard__content">
    <ng-container *ngIf="vm.step !== 'review'; else review">
      <p-floatLabel class="web-vehicle-wizard__search">
        <input pInputText id="vehicle-wizard-search" type="search" [value]="vm.query"
               (input)="updateQuery($any($event.target).value)">
        <label for="vehicle-wizard-search">
          <i class="pi pi-search" aria-hidden="true"></i>
          {{ 'features.user.garage.mobile_wizard.catalog.search' | translate:{step: (stepLabel(vm.step) | translate | lowercase)} }}
        </label>
      </p-floatLabel>

      <div *ngIf="vm.loading" class="web-vehicle-wizard__state"><app-spinner [inline]="true" size="1em"></app-spinner>{{ 'features.user.garage.mobile_wizard.catalog.loading' | translate }}</div>
      <div *ngIf="vm.error" class="web-vehicle-wizard__state"><p>{{ 'features.user.garage.mobile_wizard.catalog.error' | translate }}</p><button pButton type="button" class="p-button-outlined" (click)="retry()">{{ 'common.retry' | translate }}</button></div>
      <div *ngIf="!vm.loading && !vm.error && !filteredItems.length" class="web-vehicle-wizard__state">{{ 'features.user.garage.mobile_wizard.catalog.empty' | translate }}</div>

      <div *ngIf="!vm.loading && !vm.error && filteredItems.length" class="web-vehicle-wizard__items"
           (pointerdown)="beginListDrag($event)"
           (pointermove)="moveListDrag($event)"
           (pointerup)="endListDrag($event)"
           (pointercancel)="endListDrag($event)">
        <button *ngFor="let item of filteredItems" pButton pRipple type="button" class="p-button-outlined web-vehicle-wizard__item"
                [class.is-selected]="isSelected(item)" [disabled]="vm.changePrompt" data-testid="vehicle-wizard-option" (click)="chooseCatalogItem($event, item)">
          <span>{{ label(item) }}</span><i *ngIf="isSelected(item)" class="pi pi-check" aria-hidden="true"></i>
        </button>
      </div>
    </ng-container>

    <ng-template #review>
      <div *ngIf="vm.loading" class="web-vehicle-wizard__state"><app-spinner [inline]="true" size="1em"></app-spinner>{{ 'features.user.garage.mobile_wizard.catalog.loading' | translate }}</div>
      <div *ngIf="vm.error || vm.noMatch" class="web-vehicle-wizard__state"><p>{{ 'features.user.garage.mobile_wizard.catalog.vehicle_not_found' | translate }}</p><button pButton type="button" class="p-button-outlined" (click)="back()">{{ 'common.button.back' | translate }}</button></div>

      <section *ngIf="!vm.loading && vm.selectedVehicle" class="web-vehicle-wizard__review">
        <p-card styleClass="web-vehicle-wizard__vehicle-card">
          <ng-template pTemplate="header">
            <div class="web-vehicle-wizard__vehicle-card-banner">
              <div class="web-vehicle-wizard__vehicle-card-title">
                <small>{{ 'features.user.garage.mobile_wizard.selected_vehicle' | translate }}</small>
                <h2>{{ vm.selectedVehicle.fullVehicleIdentity }}</h2>
              </div>
              <i class="pi pi-car" aria-hidden="true"></i>
            </div>
          </ng-template>
          <div class="web-vehicle-wizard__configuration">
            <div *ngFor="let choice of choices" class="web-vehicle-wizard__configuration-choice">
              <span>{{ stepLabel(choice.step) | translate }}</span>
              <strong>{{ label(choice.item) }}</strong>
            </div>
          </div>
        </p-card>

        <p-card styleClass="web-vehicle-wizard__registration-card">
          <ng-template pTemplate="header"><h3>{{ 'features.user.garage.mobile_wizard.registration.title' | translate }}</h3></ng-template>
          <p-floatLabel>
            <input pInputText id="vehicle-registration-plate" type="text" maxlength="10" autocomplete="off"
                   [value]="vm.registration.registrationPlate" (input)="updateRegistration('registrationPlate', $any($event.target).value)">
            <label for="vehicle-registration-plate">{{ 'features.user.garage.mobile_wizard.registration.plate' | translate }}</label>
          </p-floatLabel>
          <p-floatLabel>
            <input pInputText id="vehicle-vin" type="text" maxlength="20" autocomplete="off"
                   [value]="vm.registration.vin" (input)="updateRegistration('vin', $any($event.target).value)">
            <label for="vehicle-vin">{{ 'common.vin' | translate }}</label>
          </p-floatLabel>
          <p-floatLabel>
            <p-calendar inputId="vehicle-first-registration" styleClass="web-vehicle-wizard__date-picker"
                        panelStyleClass="web-vehicle-wizard__date-picker-panel" [ngModel]="registrationDate"
                        (ngModelChange)="updateRegistrationDate($event)" [showIcon]="true" icon="pi pi-calendar"
                        [readonlyInput]="true" [touchUI]="true" dateFormat="yy-mm-dd" appendTo="body"></p-calendar>
            <label for="vehicle-first-registration">{{ 'features.user.garage.mobile_wizard.registration.first_registration' | translate }}</label>
          </p-floatLabel>
          <small *ngIf="!registrationDataValid" class="p-error">{{ 'features.user.garage.mobile_wizard.registration.invalid_date' | translate }}</small>
        </p-card>
      </section>
    </ng-template>
  </main>

  <footer *ngIf="vm.step === 'review'" class="web-vehicle-wizard__footer">
    <button pButton type="button" class="w-full web-vehicle-wizard__publish-button" [disabled]="!vm.selectedVehicle || vm.publishing || !registrationDataValid" data-testid="vehicle-wizard-publish" (click)="publish()">{{ 'features.user.garage.mobile_wizard.publish' | translate }}</button>
  </footer>

  <div *ngIf="vm.draftPrompt as draftPrompt" class="web-vehicle-wizard__prompt" role="dialog" aria-modal="true"
       [attr.aria-labelledby]="'web-vehicle-wizard-draft-' + draftPrompt">
    <section class="web-vehicle-wizard__prompt-card">
      <h2 [id]="'web-vehicle-wizard-draft-' + draftPrompt">
        {{ (draftPrompt === 'exit' ? 'features.user.garage.mobile_wizard.exit_title' : 'features.user.garage.mobile_wizard.resume_title') | translate }}
      </h2>
      <p>
        {{ (draftPrompt === 'exit' ? 'features.user.garage.mobile_wizard.exit_message' : 'features.user.garage.mobile_wizard.resume_message') | translate }}
      </p>
      <div class="web-vehicle-wizard__prompt-actions">
        <button pButton pRipple type="button" class="p-button-outlined"
                (click)="resolveDraftDecision(false)">
          {{ (draftPrompt === 'exit' ? 'features.user.garage.mobile_wizard.exit_discard_draft' : 'features.user.garage.mobile_wizard.resume_start_over') | translate }}
        </button>
        <button pButton pRipple type="button" (click)="resolveDraftDecision(true)">
          {{ (draftPrompt === 'exit' ? 'features.user.garage.mobile_wizard.exit_save_draft' : 'features.user.garage.mobile_wizard.resume_continue') | translate }}
        </button>
      </div>
    </section>
  </div>

  <div *ngIf="vm.changePrompt" class="web-vehicle-wizard__prompt" role="dialog" aria-modal="true"
       aria-labelledby="web-vehicle-wizard-change-choice-title" aria-describedby="web-vehicle-wizard-change-choice-message">
    <section class="web-vehicle-wizard__prompt-card">
      <h2 id="web-vehicle-wizard-change-choice-title">
        {{ 'features.user.garage.mobile_wizard.catalog.change_title' | translate }}
      </h2>
      <p id="web-vehicle-wizard-change-choice-message">
        {{ 'features.user.garage.mobile_wizard.catalog.change_message' | translate }}
      </p>
      <div class="web-vehicle-wizard__prompt-actions">
        <button pButton pRipple type="button" class="p-button-outlined" (click)="resolveChoiceChange(false)">
          {{ 'common.cancel' | translate }}
        </button>
        <button pButton pRipple type="button" (click)="resolveChoiceChange(true)">
          {{ 'common.confirm' | translate }}
        </button>
      </div>
    </section>
  </div>
</div>
</ng-container>
